module.exports = __webpack_public_path__ + "fonts/icon_set_2.adb7f553.woff";